export default "__VITE_ASSET__ndbyWKA0__"